import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalsService } from './globals';
import { MySubject } from './my-subject';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MTreatment } from '../models/treatment.model';

@Injectable()
export class Treatment {

    cause = new MySubject();
    finales = new MySubject();
    causeLista: any = {};

    constructor(private http: HttpClient, private globals: GlobalsService) {

    }

    /**
     * @description Pasa el estatus del tratamiento del paso 1 al 2
     * @param gncId Id de la no conformidad
     * @return Observable<any>
     * @author Miguel Ramírez
     */
    passToActionPlan(ncId: string) {
        return this.http.put(`${this.globals.apiUrl}/api/gnc/${ncId}/plan-accion`, {});
    }

    /**
     * @description No aprueba el tratamiento
     * @param gncId Id de la no conformidad
     * @return Observable<any>
     * @author Miguel Ramírez
     */
    doNotApproveTreatment(gncId: string, motive: string): Observable<any> {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/${gncId}/no-aprobar`, { observaciones: motive });
    }

    /**
     * @description Aprueba el tratamiento
     * @param gncId Id de la no conformidad
     * @return Observable<any>
     * @author Miguel Ramírez
     */
    approveTreatment(gncId: string): Observable<any> {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/${gncId}/aprobacion`, null);
    }

    /**
     * @description Pasa del paso 4 al paso 5
     * @param gncId Id de la no conformidad
     * @return Observable<any>
     * @author Miguel Ramírez
     */
    passToVerifyActions(gncId: string): Observable<any> {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/${gncId}/evaluar-eficacia`, {});
    }

    /**
     * @description Acción de no verificar el tratamiento
     * @param gncId Id de la no conformidad
     * @param data Motivo por el que no se va a realizar la aprobación
     * @return Observable<any>
     * @author Miguel Ramírez
     */
    notVerify(gncId: string, motive: string): Observable<any> {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/${gncId}/no-verificar`, {observaciones: motive});
    }

    /**
     * @description Pasa a ejecución la NC
     * @param gncId Id de la no conformidad
     * @return Observable<any>
     * @author Miguel Ramírez
     */
    passToApprovalRun(ncId: string): Observable<any> {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/${ncId}/ejecutar`, null);
    }

    /**
     * @description Pasa a verificación la NC
     * @param gncId Id de la no conformidad
     * @return Observable<any>
     * @author Miguel Ramírez
     */
    passToApproval(ncId: string): Observable<any> {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/${ncId}/verificar`, null);
    }

    /**
     * @description Obtiene un tratamiento por su id
     * @param treatmentId
     * @return Observable<any>
     * @author Miguel Ramírez
     */
    // <MTreatment>
    getTreatmentById(treatmentId: string): Observable<any> {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/${treatmentId}`)
        // .pipe(
        //     map((res:any) =>  new MTreatment(res.data))
        // )
    }

    /**
     * @description Obtiene un plan de acción
     * @param gncId Id de la no conformidad
     * @return Observable<any>
     */
    getActionPlan(gncId: string): Observable<any> {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/${gncId}/plan-accion`);
    }

    /**
     * @description Guarda el plan de acción
     * @param gncId Id de la no conformidad
     * @param data Data que se va a enviar 
     * @return Observable<any>
     */
    saveActionPlan(gncId: string, data: any): Observable<any> {
        return this.http.post(`${this.globals.apiUrl}/api/gnc/${gncId}/plan-accion`, data);
    }

    /**
     * @description Obtiene las causas de una No conformidad
     * @param gncId Id de la no conformidad
     * @return Observable
     * @author Miguel Ramírez
     */
    getListCauses(gncId: string): Observable<any> {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/${gncId}/causas`);
    }

    listMethod() {
        return this.http.get(`${this.globals.apiUrl}/api/metodo-analisis`);
    }

    listTreatment() {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/tratamiento`);
    }

    idTreatment(id) {
        return this.http.get(`${this.globals.apiUrl}/api/gnc/${id}`);
    }

    idMethodNC(id) {
        return this.http.get(`${this.globals.apiUrl}/api/metodo-analisis/no-conformidad/${id}`);
    }

    postMethodNC(id, data) {
        return this.http.post(`${this.globals.apiUrl}/api/metodo-analisis/no-conformidad/${id}`, data);
    }

    putMethodNC(id, data) {
        return this.http.put(`${this.globals.apiUrl}/api/metodo-analisis/no-conformidad/${id}`, data);
    }

    deleteMethodNC(id, data) {
        return this.http.delete(`${this.globals.apiUrl}/api/metodo-analisis/no-conformidad/${id}`);
    }

    getListCausa(ncId, array) {
        return this.http.get(`${this.globals.apiUrl}/api/metodo-analisis/no-conformidad/${ncId}/causas?metodo=${array} `);
    }

    createAnalisis(metodoId, ncId, data) {
        return this.http.post(`${this.globals.apiUrl}/api/metodo-analisis/${metodoId}/no-conformidad/${ncId}/causas `, data);
    }

    get getCauseList(): Observable<any> {
        return this.cause.asObservable();
    }

    setCauseList(data) {
        this.cause.next(data);
    }

    get getFinalesList(): Observable<any> {
        return this.finales.asObservable();
    }

    setFinalesList(data) {
        this.finales.next(data);
    }

    clearCauseList() {
        this.causeLista = {};
        this.cause.next([]);
        this.finales.next([]);
    }
}
